class Client {
  constructor() {
    this.id = 0
    this.caption = ""
    this.description = ""
    this.active = true
  }
}

class Campaign {
  constructor() {
    this.cliente = {
      id: 0,
      campaigns: []
    }
    this.id = 0
    this.ci_id = 0
    this.fe_id = 0
    this.caption = ""
    this.descripcion = ""
    this.leads = 0
    this.imagen = ""
    this.active = true
    this.destinatarios = []
    this.mensaje = {
      exito: "Gracias por confiar en nosotros",
      error: "Ha ocurrido un error"
    }
    this.boton = {
      caption: "Enviar formulario",
      color: "#00acee",
      textcolor: "#ffffff"
    }
    this.form = {}
  }
}

export {
  Campaign,
  Client
}